import { ClaimStatus } from "../enums/claim-status.enum";

export class CreateClaimStateDTO{
    status: ClaimStatus;
    observation: string;
    
    constructor(status:ClaimStatus, observation: string){
        this.status = status;
        this.observation = observation;
    }
}